import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';

import styles from './LegalFounderStatement.module.scss';

export const LegalFounderStatement = () => {
  const { t } = useInt();

  return (
    <Section className={styles.root}>
      <div className={styles.inner}>
        <p className={styles.quote}>
          {t(
            'We built this because every alternative we looked at put a reseller between the register and the record.',
          )}{' '}
          <em>{t("If you cannot point at the filing, you do not have evidence. You have someone's summary of it.")}</em>
        </p>
        <div className={styles.by}>
          <span className={styles.mark} />
          <span>
            <span className={styles.name}>Nic Buldumac</span>
            <span className={styles.role}>{t('Founder and CEO, Global Database')}</span>
          </span>
        </div>
      </div>
    </Section>
  );
};
